import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import { createBrand, fetchAllBrands } from './BrandApi'

const initialState={
    status:"idle",
    brands:[],
    errors:null
}

export const fetchAllBrandsAsync=createAsyncThunk('brands/fetchAllBrandsAsync',async()=>{
    const brands=await fetchAllBrands()
    return brands
})

export const createBrandAsync = createAsyncThunk('brands/createBrandAsync', async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state?.AuthSlice?.loggedInUser?.token;
    const brand = await createBrand(data, token);
    return brand;
});

const brandSlice=createSlice({
    name:"brandSlice",
    initialState:initialState,
    reducers:{},
    extraReducers:(builder)=>{
        builder
            .addCase(fetchAllBrandsAsync.pending,(state)=>{
                state.status='idle'
            })
            .addCase(fetchAllBrandsAsync.fulfilled,(state,action)=>{
                state.status='fulfilled'
                state.brands=action.payload
            })
            .addCase(fetchAllBrandsAsync.rejected,(state,action)=>{
                state.status='rejected'
                state.errors=action.error
            })
            .addCase(createBrandAsync.fulfilled,(state,action)=>{
                state.brands.push(action.payload)
            })

    }
})

// exporting selectors
export const selectBrandStatus=(state)=>state.BrandSlice.status
export const selectBrands=(state)=>state.BrandSlice.brands
export const selectBrandErrors=(state)=>state.BrandSlice.errors

export default brandSlice.reducer
